import React from 'react';

import {OptionCard} from '../OptionCard';
import {AgentUseCase, getUseCaseCopy} from '../PromptView/promptConfigs';

interface Props {
  useCase: AgentUseCase;
  compareMode: boolean;
  selected: boolean;
  disabled: boolean;
  onSelect: (key: string) => void;
  tag?: string;
}

export const UseCaseCard: React.FC<Props> = ({
  useCase,
  compareMode,
  selected,
  disabled,
  onSelect,
  tag,
}) => {
  const {label, description, disabledInCompare} = getUseCaseCopy(useCase, compareMode);
  return (
    <OptionCard
      title={label}
      description={description}
      tag={tag}
      selected={selected}
      disabled={disabled || disabledInCompare}
      onSelect={() => onSelect(useCase.key)}
    />
  );
};
